import { SphereDropdownButtonProps } from "@components/common/dropdown/sphere-dropdown-selector-types";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { FaroTextButton } from "@components/common/faro-text-button";
import { Text, ExportIcon } from "@flat-ui";

interface Props extends SphereDropdownButtonProps {
  /** Text to display as tooltip on the drop-down button */
  buttonTooltipText: string;
}

/**
 * Export button styled for bulk actions (export all data).
 * Displays a download icon followed by the label text.
 */
export function BulkExportButton({
  isOpen,
  onClick,
  label,
  buttonTooltipText,
}: Props): JSX.Element {
  const mode = useBulkActionsMode();
  const config = getBulkActionButtonConfig(mode, buttonTooltipText);

  return (
    <FaroTextButton
      onClick={onClick}
      tooltipText={config.tooltipText}
      loadingTrackColor={config.loadingTrackColor}
      startIcon={<ExportIcon sx={{ height: 18, width: 18 }} />}
      rippleColor={config.rippleColor}
      sx={config.sx}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
    >
      {config.shouldShowText && <Text variant="buttonM">{label}</Text>}
    </FaroTextButton>
  );
}
